
import React, { useState, useEffect } from 'react';
import { Grid, TextField, Box, Button, Typography, Paper, InputAdornment,  FormControl } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useLocation } from 'react-router-dom';

const Payment = () => {
  const [formData, setFormData] = useState({
    amount: '',
    purpose: '',
    buyer_name: '',
    email: '',
    phone: '',
    selectedImage:''
  });


  const location = useLocation();
  console.log("form Data", formData);
  console.log("location", location);

  useEffect(() => {
    if (location.state) {
      let obj = {
        amount: location.state.amount,
        purpose: location.state.purpose,
        buyer_name: location.state.buyer_name,
        email: location.state.Email,
        phone: location.state.Mobile,
        selectedImage: location.state.selectedImage,
      }
      setFormData(obj);
    }
  }, [])


  const [paymentStatus, setPaymentStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoneChange = (phone) => {
    setFormData({
      ...formData,
      phone,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.purpose || !formData.amount || !formData.buyer_name || !formData.email || !formData.phone) {
      setPaymentStatus('Please fill in all required fields.');
      return;
    }

    const baseUrl = window.location.origin; 

    const paymentDetails = {
      purpose: formData.purpose,
      amount: formData.amount,
      buyer_name: formData.buyer_name,
      email: formData.email,
      phone: formData.phone,
      redirect_url: `${baseUrl}/payment-success`, 
      redirecturl: `${baseUrl}/payment-success/`, 
      webhook_url: '',
    };

    // try {
    //   const response = await axios.post(
    //     'https://cors-anywhere.herokuapp.com/https://www.instamojo.com/api/1.1/payment-requests/',
    //     paymentDetails,
    //     {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU',
    //         'X-Api-Key': '9fb75fe0b2d1b2d3d19e7f64bfac5075',
    //         'X-Auth-Token': '5e1edf9fd85f643e945e1423b7e3b45b',
    //       },
    //     }
    //   );


    //   if (response.data.success) {
    //     setPaymentStatus('Payment request created successfully!');
    //     window.location.href = response.data.payment_request.longurl; // Redirect to Instamojo payment URL
    //   } else {
    //     setPaymentStatus('Error occurred during payment request creation.');
    //   }
    // } catch (error) {
    //   console.error('Error making payment request:', error);
    //   setPaymentStatus('Error occurred during payment request creation.');
    // }



    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}Payment/CreatePaymentOrder`,
        paymentDetails,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU',
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      console.log(JSON.parse(response.data));
      let obj = JSON.parse(response.data);
      window.location.href = obj.payment_request.longurl;
    } catch (error) {
      console.error('Error making payment request:', error);
      setPaymentStatus('Error occurred during payment request creation.');
    }

  };


  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 2,
          maxWidth: 600,
          width: '100%',
        }}
      >
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#635bff' }}>
          Payment Gateway
        </Typography>
        <Typography variant="body1" gutterBottom align="center" sx={{ marginBottom: 3 }}>
          Fill in your details below to proceed with the payment.
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Your Name"
                name="buyer_name"
                value={formData.buyer_name}
                onChange={handleChange}
                required
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
                onInput={(e) => {
                  const inputValue = e.target.value;
                  if (!/^[a-zA-Z\s]*$/.test(inputValue)) {
                    e.target.value = inputValue.slice(0, -1);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <PhoneInput
                country="in"
                value={formData.phone}
                onChange={handlePhoneChange}
                disabled={true}
                inputStyle={{
                  width: '100%',
                  height: '56px',
                  borderRadius: '4px',
                  borderColor: '#c4c4c4',
                  fontSize: '16px',
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                  id="outlined-adornment-weight"
                  startAdornment={
                    <InputAdornment position="start">
                      <div
                        style={{
                          width: 25,
                          height: 15,
                          backgroundImage: `url(${formData.selectedImage})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          borderRadius: '4px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                    </InputAdornment>
                  }
                  aria-describedby="outlined-weight-helper-text"
                  style={{ width: "100%", height: 40 }}
                  inputProps={{
                    'aria-label': 'weight',
                    style: { height: 40 }, 
                  }}
                  placeholder={`Enter Valid  Mobile Number`}
                  value={formData.phone}
                  disabled={true}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Purpose of Payment"
                name="purpose"
                value={formData.purpose}
                onChange={handleChange}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CreditCardIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Amount"
                name="amount"
                type="number"
                value={formData.amount}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#635bff',
                  '&:hover': {
                    backgroundColor: '#4c47cc',
                  },
                }}
              >
                Pay Now
              </Button>
            </Grid>
          </Grid>
        </form>
        {paymentStatus && (
          <Typography variant="body2" color="error" align="center" sx={{ marginTop: 3 }}>
            {paymentStatus}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default Payment;
